// extracted by mini-css-extract-plugin
module.exports = {"colorSlider":"colorSlider--1hXCe","titleWrap":"titleWrap--2TP6V","colorpicker":"colorpicker--2S1Yi"};